import { render, staticRenderFns } from "./ClosedCard.vue?vue&type=template&id=3645a9aa&scoped=true&"
import script from "./ClosedCard.vue?vue&type=script&lang=js&"
export * from "./ClosedCard.vue?vue&type=script&lang=js&"
import style0 from "./ClosedCard.vue?vue&type=style&index=0&id=3645a9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3645a9aa",
  null
  
)

export default component.exports